<template>
  <v-container id="travel">
    <v-layout column>
      <v-flex class="display-2 text-xs-center my-5">Travel</v-flex>
      <v-divider insert></v-divider>
      <v-container xl5 lg6 md8 sm12 xs12 fluid grid-list-xl id="hotels">
        <v-flex class="display-1 text-xs-left my-5">Hotels</v-flex>
        <v-layout row wrap>
          <v-flex d-flex xs12 sm12 md4 lg4 v-for="hotel in hotels" :key="hotel.name">
            <v-card>
              <v-card-title><b>{{ hotel.name }}</b></v-card-title>
              <v-card-text v-html="hotel.description">{{ hotel.description }}</v-card-text>
              <v-card-text v-if="hotel.block_url" />
              <v-card-text>
                <a :href="hotel.google_maps_location" target="_blank">
                  {{ hotel.location }}
                </a>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn primary :href="hotel.google_maps_directions" target="_blank">
                  <span>DIRECTIONS</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container xl5 lg6 md8 sm12 xs12 fluid grid-list-xl id="other">
        <v-flex class="display-1 text-xs-left my-5">Other Options</v-flex>
        <v-layout row wrap>
          <v-flex d-flex xs12 sm12 md4 lg4 v-for="other in others" :key="other.name">
            <v-card>
              <v-card-title><b>{{ other.name }}</b></v-card-title>
              <v-card-text>{{ other.description }}</v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn primary :href="other.link" target="_blank">
                  <span>DETAILS</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Travel',
  data() {
    return {
      hotels: [
        {
          name: 'Hilton Boston Downtown/Faneuil Hall',
          location: '89 Broad Street, Boston, MA 02110',
          description: 'We have a room block at the Hilton Boston downtown. This is less than 1/4 mile from the venue and has really nice accomidations. To make a reservation, call (617) 556-0006 and let them know the wedding is under McDade/Liu',
          google_maps_directions: 'http://bit.ly/2KEwcXb',
          google_maps_location: 'http://bit.ly/2ZRiR4c',
        },
        {
          name: 'Marriott Long Warf',
          location: '296 State St, Boston, MA 02109',
          description: 'We have a room block at the Marriott Long Warf. This is directly next to the venue and has really nice accomidations. To make a reservation, call (617) 227-0800 and let them know the wedding is under McDade/Liu',
          google_maps_directions: 'http://bit.ly/2YZjlb6',
          google_maps_location: 'http://bit.ly/2TuEKUA',
        },
        {
          name: 'Battery Warf Hotel Boston Waterfront',
          location: '3 Battery Wharf, Boston, MA 02109',
          description: 'We have a room block at the Battery Warf Hotel of Boston. This is about 3/4 of a mile from the venue. <a href="https://book.passkey.com/go/McDadeLiuWedding" target="_blank">https://book.passkey.com/go/McDadeLiuWedding</a>',
          google_maps_directions: 'http://bit.ly/2YZjlb6',
          google_maps_location: 'http://bit.ly/2ZW7PL0',
          block_url: 'https://book.passkey.com/go/McDadeLiuWedding',
        },
      ],
      others: [
        {
          name: 'Airbnb',
          description: 'There are lots of Airbnb options for Boston as well. Feel free to take a look and see if anything will work for you!',
          link: 'http://bit.ly/33si4bZ',
        },
        {
          name: 'Hotels.com',
          description: 'Feel free to check Hotels.com, Kayak.com, Orbitz or Travelocity if they work for you!',
          link: 'http://bit.ly/2YX7jiw',
        },
      ],
    };
  },
};
</script>

<style scoped></style>
